import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'

import 'react-html5-camera-photo/build/css/index.css'
import logoSpotter from '../../images/login-spotter-logo.png'
import ListHeader from '../common/ListHeader'
import { FieldTypes } from '../../utils/constants'
import Form from '../common/Form'

export default function UserInvitationForm({
  onSubmit,
  invitation,
  responseError,
  loading,
}) {
  const classes = useStyles()
  const [values, setValues] = useState({})

  useEffect(() => {
    setValues({ ...invitation })
  }, [invitation])

  const handleTakePhoto = (dataUri) => {
    setValues({ ...values, selfie: dataUri })
  }

  if (loading) {
    return (
      <div className={classes.paper}>
        <CircularProgress></CircularProgress>
      </div>
    )
  }
  if (responseError && responseError.message) {
    return (
      <div style={{ color: '#d51616', marginTop: '20px', fontSize: '16px' }}>
        {responseError.message}
      </div>
    )
  }
  return (
    <div className={classes.paper}>
      <div className={classes.wrapper}>
        <img
          src={logoSpotter}
          style={{
            marginBottom: '20px',
            marginRight: '40px',
            marginTop: '20px',
          }}
          width="180px"
          alt="spotter"
        />
        <ListHeader bigTitle="Registro de invitado" canCreate={false} />
        <Form
          values={values}
          setValues={setValues}
          mobile
          fields={[
            {
              type: FieldTypes.TextField,
              label: 'Nombre',
              hint: 'Ingrese un nombre',
              key: 'firstName',
              errorMessage: 'El nombre es requerido',
              capitalized: true,
            },
            {
              type: FieldTypes.TextField,
              label: 'Apellido',
              hint: 'Ingrese un apellido',
              key: 'lastName',
              errorMessage: 'El apellido es requerido',
              capitalized: true,
            },
            {
              type: FieldTypes.TextField,
              label: 'Teléfono',
              hint: 'Ingrese un teléfono',
              key: 'phone',
              errorMessage: 'El teléfono es requerido',
            },
            {
              type: FieldTypes.TextField,
              label: 'Cédula',
              hint: 'Ingrese una cédula',
              key: 'ci',
              errorMessage: 'La cédula es requerida',
            },
            {
              type: FieldTypes.TakePhoto,
              image: values.selfie,
              removePhoto: () => setValues({ ...values, selfie: null }),
              takePhoto: (dataUri) => {
                handleTakePhoto(dataUri)
              },
            },
          ]}
          handleSubmit={() => onSubmit({ ...values, shouldCreatePin: true })}
        />
      </div>
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& .Mui-error': {
      color: 'white',
    },
    '& .MuiFormHelperText-root': {
      color: '#f44336',
    },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    minHeight: '100vh',
    position: 'relative',
    '.react-html5-camera-photo>img': {
      width: '100%',
    },
  },
  wrapper: {
    maxWidth: '768px',
    margin: '0 auto',
  },
}))
